import { baseService } from "src/store/base.store";
import { executeQuery } from "src/store";
import { statsQueryHandler } from "./query-handler.service";
import { UserLangCode } from "src/utils/util.types";
import { StatsPayload } from "../types";
import { queryResultAdapter } from "../utils/queryHandleAdapter";

const statisticsService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getAllStatistics: builder.query<StatsPayload, { langCode?: UserLangCode }>({
      queryFn: async ({ langCode }) =>
        executeQuery(async () => {
          console.log("new fetch", langCode);
          const expiry = statsQueryHandler.getCategoriesExpiry();
          const flat = await statsQueryHandler.getAllStats(langCode);
          const stats = queryResultAdapter(flat);
          return { stats, expiry };
        }),
      forceRefetch({}) {
        return true;
      },
    }),
  }),
});

export const { useGetAllStatisticsQuery } = statisticsService;
